module.exports = __webpack_public_path__ + "site/img/indexsd1en.a97dff53.jpg";